import {
  CtaBuilderFn,
  InstantAnswerBuilderFn,
  InstantAnswerContext,
  InstantAnswerScenario,
} from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

import { ShippingContextDataFn } from "../../instantAnswerDataFunctions/shippingContextDataFn";
import { ShouldDisplayMessageCTADataFn } from "../../instantAnswerDataFunctions/shouldDisplayMessageCTADataFn";

import { GoToOrderFulfillmentCTA, ViewOrdersCTA } from "./ctas";

export const ShipFromAddressIA: InstantAnswerBuilderFn = (strictLocalize) => {
  return {
    titleBuilder: (context) => {
      return getAnswer(context, strictLocalize).getTitle();
    },

    descriptionBuilder: (context) => {
      return getAnswer(context, strictLocalize).getDescription();
    },

    primaryCtaBuilder: {
      textBuilder: (context) => {
        return getPrimaryCTA(context, strictLocalize)?.label;
      },
      linkBuilder: (context) => {
        return getPrimaryCTA(context, strictLocalize)?.getLink?.();
      },
    },

    additionalRequiredData: [
      ShippingContextDataFn,
      ShouldDisplayMessageCTADataFn,
    ],
  };
};

const getAnswer = (
  _context: InstantAnswerContext,
  strictLocalize: StrictLocalizeFunction
): InstantAnswerScenario => {
  return {
    getTitle: () => SHIP_FROM_ADDRESS_TITLE(strictLocalize),
    getDescription: () => [
      SHIP_FROM_ADDRESS_DESCRIPTION_LIST1(strictLocalize),
      SHIP_FROM_ADDRESS_DESCRIPTION_LIST2(strictLocalize),
      SHIP_FROM_ADDRESS_DESCRIPTION_LIST3(strictLocalize),
      SHIP_FROM_ADDRESS_DESCRIPTION_LIST4(strictLocalize),
    ],
  };
};

const SHIP_FROM_ADDRESS_TITLE = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "How to update your ship from address",
    description: {
      text: "Title for the answer of changing the ship from address",
      img: "https://cdn.faire.com/fastly/8e8222e5051e94042e4da188af6168191b359bb6356305baf1bbd890cf898133.png",
    },
  });

const SHIP_FROM_ADDRESS_DESCRIPTION_LIST1 = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage: "1. Go to your Orders.",
  });

const SHIP_FROM_ADDRESS_DESCRIPTION_LIST2 = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage: "2. Click on any order.",
  });
const SHIP_FROM_ADDRESS_DESCRIPTION_LIST3 = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage: "3. Edit the ship from address.",
  });
const SHIP_FROM_ADDRESS_DESCRIPTION_LIST4 = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage: "4. Save any changes you make.",
  });

const getPrimaryCTA: CtaBuilderFn = (
  context: InstantAnswerContext,
  strictLocalize: StrictLocalizeFunction
) => {
  const brandOrderToken = context.brandOrder?.brand_order?.token;
  if (!brandOrderToken) {
    return ViewOrdersCTA(strictLocalize);
  }

  return GoToOrderFulfillmentCTA(brandOrderToken, strictLocalize);
};
